import { render } from "./AfterSalesList.vue?vue&type=template&id=1bc9d8b8&scoped=true"
import script from "./AfterSalesList.vue?vue&type=script&lang=js"
export * from "./AfterSalesList.vue?vue&type=script&lang=js"

import "./AfterSalesList.vue?vue&type=style&index=0&id=1bc9d8b8&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc9d8b8"]])

export default __exports__